<i18n src="./../../i18n/home_page.json"></i18n>

<template>
    <div id="home-page">
        <vue-headful
                :title="$t('pageTitle')"
                :description="$t('pageDescription')"
                :url="pageUrl"/>
        <div class="container-fluid">
            <navigation-bar :is-on-front-page="true"/>

            <!-- Offer carousel -->
            <offer-carousel v-bind:carouser-data="content.offerCarouselItems" />

            <div class="container pt-4">
                <div class="row">
                    <div class="col text-center">
                        <h2 v-text="$t('news.title')"/>
                    </div>
                </div>
            </div>

            <div class="container pt-4 container-custom">
                <div class="row">
                    <div class="col">
                        <carousel v-if="loaded"
                                :autoplay="true"
                                :nav="false"
                                :margin="20"
                                :loop="true"
                                :dots="true"
                                :autoplayTimeout="6000"
                                :responsiveClass="true"
                                :smartSpeed="2000"
                                :responsive="{0:{items:1},800:{items:2},1200:{items:3}}">

                            <div class="card" v-for="info in content.infoItems" :key="info.title">
                                <router-link :to="{name: 'infoPage', params: {pageName: cleanPath(info.url)}}" class="card-img-wrapper">
                                    <img class="lazy card-img-top" :data-src="info.image" :alt="info.imageAlt">
                                </router-link>
                                <div class="card-body">
                                    <router-link :to="{name: 'infoPage', params: {pageName: cleanPath(info.url)}}">
                                        <h6 class="card-title pb-0 mb-0" v-text="info.title"/>
                                    </router-link>
                                    <p class="card-text"><small class="text-muted" v-text="info.date"/></p>
                                </div>
                            </div>
                        </carousel>
                    </div>
                </div>
            </div>

            <!-- About paralax -->
            <div id="o-firmie" class="mt-5"></div>
            <div id="mt-about-section" class="lazy jumbotron paralax paralax-about-section" data-bg="/assets/mt-about-paralax.jpg">
                <div class="container">
                    <p class="display-1 mt-f-regular" v-text="$t('about.title')"/>
                </div>
            </div>

            <!-- About content -->
            <div class="container pt-4">
                <div class="row">
                    <div class="col text-center">
                        <h2 v-text="$t('about.header')"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col text-center">
                        <h1 class="subtitle mt-c-grey" v-text="$t('about.content')"/>
                    </div>
                </div>
            </div>

            <div class="container">
                <div class="row pt-4 pb-5">
                    <about-item v-for="item in content.aboutItems"
                                :key="item.title"
                                v-bind:item-data="item"/>
                </div>
            </div>

            <!-- Contact -->
            <div id="kontakt" class="mt-5"></div>
            <main-map :map-data="content.departmentItems"/>

            <!-- Footer -->
            <div class="container-fluid mt-contact-section">
                <div class="lazy container-fluid">
                    <div class="text-center pt-4">
                        <router-link :to="{name: 'contact'}">
                            <button type="button" class="btn btn-secondary btn-lg mt-button mt-button-secondary mt-button-border ml-3 mr-3 mt-2 pl-5 pr-5">{{ $t('contact.title') }} <font-awesome-icon class="" icon="angle-double-right"/></button>
                        </router-link>
                    </div>
                    <div class="pt-5 pb-5">
                        <div class="pt-5 mt-4 mb-5 text-center">
                            <h2 v-text="$t('contact.header')"/>
                        </div>
                    </div>
                    <contact-form/>

                    <div class="container">
                        <main-footer/>
                    </div>

                </div>
            </div>

        </div>

      <div class="mtoilet-popup-overlay mtoilet-hidden" id="mToiletPopup">
        <div class="mtoilet-popup-content">
          <button class="mtoilet-popup-close" v-on:click="closeMToiletPopup()" aria-label="Uždaryti">&times;</button>

          <div class="mtoilet-badge">Naujiena!</div>
          <h2 class="mtoilet-popup-title">mToilet</h2>
          <p class="mtoilet-popup-subtitle">
            Užsisakykite tualetus internetu vos per kelias minutes.
          </p>
          <p class="mtoilet-popup-text">
            Pradėjome naują internetinę parduotuvę, kurioje greitai ir patogiai užsisakysite mūsų biotualetus.
          </p>

          <a href="https://mtoilet.lt/pasiulymas/biotualetai" class="mtoilet-popup-btn">
            Peržiūrėkite pasiūlymą ir užsisakykite internetu
          </a>
        </div>
      </div>


    </div>
</template>

<script>
    import {Const} from "@/main";
    import NavigationBar from "@/components/commons/NavigationBar";
    import OfferCarousel from "@/components/home/OfferCarousel";
    import $ from 'jquery'
    import AboutItem from "@/components/home/AboutItem";
    import ContactForm from "@/components/commons/ContactForm";
    import MainFooter from "@/components/commons/MainFooter";
    import LazyLoad from "vanilla-lazyload";
    import axios from 'axios'
    import carousel from 'vue-owl-carousel'
    import MainMap from "../commons/MainMap";

    var lazyLoadInstance = new LazyLoad({
        threshold: 0,
        elements_selector: ".lazy",
        callback_loaded: function (element) {
            if (element.className.indexOf("card-img-top") > -1) {
                let nextElement = element.closest(".owl-item").nextElementSibling;
                if (nextElement) {
                    lazyLoadInstance.load(nextElement.getElementsByClassName("card-img-top")[0])
                }
            }
        }
    });

    export default {
        name: "HomePage",
        components: {MainMap, MainFooter, ContactForm, AboutItem, OfferCarousel, NavigationBar, carousel},
        data () {
            return {
                locale: this.$i18n.locale,
                content: {},
                loaded: false,
                pageUrl: Const.HOST + this.$route.path,
                slickOptions: {
                    slidesToShow: 3,
                }
            }
        },
        mounted() {
            axios.get(`${Const.API_HOST}/${this.locale}/content/home`)
                .then(function (response) {
                    return response.data;
                }).catch(function (error) {
                // eslint-disable-next-line no-console
                console.log(error);
            }).then(body => {
                this.content = body
                this.loaded = true

                if (window['__PRERENDER_INJECTED']) {
                  // eslint-disable-next-line no-console
                  console.log("render mode")
                } else {
                  if (!this.isMobileDevice() && this.$i18n.locale === 'lt') {
                    setTimeout(function () {
                      document.getElementById('mToiletPopup').classList.remove('mtoilet-hidden');
                    }, 2000)
                  }
                }

                this.$nextTick(() => {
                    lazyLoadInstance.update()
                })
            });

            $(document).scroll(function () {
                var $nav = $(".navbar-light");
                $nav.removeClass('initial');
                $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());
            });
            document.getElementById('mToiletPopup').addEventListener('click', function(event) {
              if (event.target === this) {
                document.getElementById('mToiletPopup').classList.add('mtoilet-hidden');
              }
            });
        },
        methods: {
            cleanPath(path) {
                return path.startsWith('/') ? path.substring(1) : path;
            },
            isMobileDevice() {
              let check = false;
              (function (a) {
                if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) check = true;
              })(navigator.userAgent || navigator.vendor || window.opera);
              return check;
            },
            closeMToiletPopup() {
              document.getElementById('mToiletPopup').classList.add('mtoilet-hidden');
            }
        }
    }
</script>

<style scoped>

    .mt-contact-section > .container-fluid {
        background-image: linear-gradient(to top, transparent 0%, transparent 600px, #91A7BD 600px, #91A7BD 606px, #C9D3DE 606px, #C9D3DE 612px, white 612px, white 100%);
    }

    @media (max-width: 768px) {
        .mt-contact-section > .container-fluid {
            background-image: linear-gradient(to top, transparent 0%, transparent 1280px, #91A7BD 1280px, #91A7BD 1286px, #C9D3DE 1286px, #C9D3DE 1292px, white 1292px,  white 100%);
        }
    }

    .subtitle {
      font-size: 1rem;
    }

    @media (min-width: 1600px) {
        .container-custom {
            max-width: 1520px;
        }
    }

    .card {
        border-radius: 0;
    }

    .card-body {
        padding: 0.7rem;
    }

    .card-title {
        line-height: 1.2rem;
        height: 2.4rem;
        overflow: hidden;
    }

    .card-img-wrapper {
        height: 25vh;
    }

    .card-img-wrapper img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }

    .paralax {
        min-height: 300px;
        background-attachment: fixed;
        background-size: cover;
        background-position: 50% 50%;
        opacity: 0.75;
        filter: alpha(opacity=75);
        z-index: 1;
    }

    .paralax p, .mt-carousel-offer-text p {
        color: #000;
        opacity: 0.50;
        filter: alpha(opacity=60);
        padding-top: 265px;
        line-height: 0;
        text-align: right;
    }

    @media (max-width: 768px) {
        .paralax p {
            padding-top: 276px;
            font-size: 4rem;
        }
    }

    .card:hover {
        box-shadow: 0 0 30px -15px rgba(0, 0, 0, 0.2);
        transition: box-shadow 0.1s ease-in-out;
    }

    /* Tło popupa (nakładka) */
    .mtoilet-popup-overlay {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.5); /* Półprzezroczyste ciemne tło */
      backdrop-filter: blur(4px); /* Efekt nowoczesnego rozmycia tła */
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 99999;
      font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
      opacity: 0;
      animation: mtoiletFadeIn 0.3s forwards ease-out;
    }

    /* Główne okienko popupa */
    .mtoilet-popup-content {
      background-color: #ffffff;
      width: 90%;
      max-width: 480px;
      border-radius: 16px;
      padding: 40px 30px;
      text-align: center;
      position: relative;
      box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
      transform: translateY(20px) scale(0.95);
      animation: mtoiletSlideUp 0.4s 0.1s forwards cubic-bezier(0.175, 0.885, 0.32, 1.275);
      opacity: 0;
    }

    /* Przycisk zamykania (krzyżyk) */
    .mtoilet-popup-close {
      position: absolute;
      top: 15px;
      right: 15px;
      background: none;
      border: none;
      font-size: 28px;
      color: #a0aec0;
      cursor: pointer;
      transition: color 0.2s ease;
      line-height: 1;
      padding: 0;
      width: 32px;
      height: 32px;
    }

    .mtoilet-popup-close:hover {
      color: #2d3748;
    }

    /* Etykieta "Naujiena" */
    .mtoilet-badge {
      display: inline-block;
      background-color: #ebf8ff; /* Jasnoniebieskie tło */
      color: #3182ce; /* Niebieski tekst */
      font-weight: 700;
      font-size: 13px;
      padding: 6px 14px;
      border-radius: 20px;
      text-transform: uppercase;
      letter-spacing: 1.5px;
      margin-bottom: 20px;
    }

    /* Teksty w popupie */
    .mtoilet-popup-title {
      color: #2d3748;
      font-size: 26px;
      font-weight: 800;
      margin: 0 0 15px 0;
    }

    .mtoilet-popup-subtitle {
      color: #4a5568;
      font-size: 18px;
      font-weight: 600;
      margin: 0 0 12px 0;
      line-height: 1.4;
    }

    .mtoilet-popup-text {
      color: #718096;
      font-size: 15px;
      line-height: 1.6;
      margin: 0 0 25px 0;
    }

    /* Główny przycisk wezwania do akcji (CTA) */
    .mtoilet-popup-btn {
      display: inline-block;
      background-color: #3182ce;
      color: #ffffff;
      text-decoration: none;
      font-weight: 600;
      font-size: 16px;
      padding: 16px 24px;
      border-radius: 8px;
      transition: all 0.3s ease;
      box-shadow: 0 4px 12px rgba(49, 130, 206, 0.3);
      width: 100%;
      box-sizing: border-box;
    }

    .mtoilet-popup-btn:hover {
      background-color: #2b6cb0;
      transform: translateY(-2px);
      box-shadow: 0 6px 16px rgba(49, 130, 206, 0.4);
      color: #ffffff;
    }

    /* Animacje */
    @keyframes mtoiletFadeIn {
      to { opacity: 1; }
    }

    @keyframes mtoiletSlideUp {
      to {
        opacity: 1;
        transform: translateY(0) scale(1);
      }
    }

    /* Klasa do ukrywania popupa */
    .mtoilet-hidden {
      display: none !important;
    }
</style>